// ============================================================================
// CONFIGURATION
// ============================================================================
import {
    BATCH_SIZE,
    CHAT_HISTORY_LIMIT,
    CHAT_HISTORY_FETCH_LIMIT,
    PARTICIPANT_BATCH_SIZE,
    RECENT_CHAT_FETCH_LIMIT,
} from '../../../../Helpers/Constants';
import { encryptAndStoreInLocalStorage, getFromLocalStorageAndDecrypt } from '../../WebChatEncryptDecrypt';
import logger from '../../../../Helpers/logger';

export const CONFIG = {
    // Sync state
    lastSyncTime: getFromLocalStorageAndDecrypt('lastSyncTime') || 0,

    // Messages sync state by chat jid
    lastSyncMessagesTime: {},

    // Pagination
    RECENT_CHAT_FETCH_LIMIT,

    BATCH_SIZE,

    PARTICIPANT_BATCH_SIZE,

    CHAT_HISTORY_LIMIT,

    CHAT_HISTORY_FETCH_LIMIT,
};

export const updateLastSyncTime = time => {
    const syncTime = time || Date.now();
    CONFIG.lastSyncTime = syncTime;
    encryptAndStoreInLocalStorage('lastSyncTime', syncTime);
};

export const updateLastSyncMessagesTime = (chatId, time) => {
    CONFIG.lastSyncMessagesTime[chatId] = time;
};

export const batchUpdateLastSyncMessagesTime = timeMap => {
    Object.assign(CONFIG.lastSyncMessagesTime, timeMap);
};

export const getLastSyncMessagesTime = chatId => {
    return CONFIG.lastSyncMessagesTime[chatId] || 0;
};

if (typeof window !== 'undefined') {
    window.getConfig = () => {
        logger.debug('[MessagesIdb] getConfig', CONFIG);
        return CONFIG;
    };
}
